import React, { useState } from 'react';
import Styles from './total-savings-styles.scss';
import { IconEmergencyFund, IconIndonesiaTrip, IconGeneralAccount, IconSettingSavings, IconSavingsDeposit, IconSavingsWithdraw, IconEntertainment, IconHousing } from '@/presentation/components/icons';
import WalletComponent from '@/presentation/pages/my-wallet-savings/components/wallet-component/wallet-component';
import TagDefault from '@/presentation/pages/my-wallet-savings/components/tag-default/tag-default';
import WalletSection from '@/presentation/pages/my-wallet-savings/components/wallet-section/wallet-section';
import { useLocation, useNavigate } from 'react-router';
import useStudentAccounts from '@/presentation/hooks/use-student-accounts';
import { formatAccountBalance, parseVirtualAccountBalance, sumBalances } from '@/presentation/utils/money-utils';
import TransferFundsModalWrapper from '@/presentation/pages/transfer-funds-modal/transfer-funds-modal';
import ModalUpdateSaving from './modal-update-saving';
import { modalUpdateSavingState } from './components/atoms';
import { useRecoilState } from 'recoil';
export const SAVING_CATEGORIES = [
    {
        id: 41,
        icon: React.createElement(IconEmergencyFund, { color: "#00A3FF" }),
        text: 'Emergency Fund'
    },
    {
        id: 44,
        icon: React.createElement(IconIndonesiaTrip, { color: "#00A3FF" }),
        text: 'Vacation and Traveling'
    },
    {
        id: 42,
        icon: React.createElement(IconEntertainment, { color: "#00A3FF" }),
        text: 'Entertainment'
    },
    {
        id: 40,
        icon: React.createElement(IconHousing, { color: "#00A3FF" }),
        text: 'Housing'
    }
];
const getCategoryIcon = (idCategory) => {
    const category = SAVING_CATEGORIES.find(category => category.id === idCategory);
    return (category === null || category === void 0 ? void 0 : category.icon) ? React.cloneElement(category.icon, { color: '#FFA800' }) : React.createElement(IconGeneralAccount, { color: "#FFA800" });
};
const TotalSavings = ({ validationTransferFunds, manageVirtualTransactions, validationModalUpdateSaving, manageVirtualAccounts, reloadTransactions }) => {
    const [openModalFunds, setOpenModalFunds] = useState(false);
    const [accountFromParam, setAccountFromParam] = useState(null);
    const [accountToParam, setAccountToParam] = useState(null);
    const [stateUpdate, setStateUpdate] = useRecoilState(modalUpdateSavingState);
    const navigate = useNavigate();
    const location = useLocation();
    const { pockets, checkingAccount } = useStudentAccounts(false);
    const totalSavings = sumBalances(pockets);
    const deposit = (accountIdParam) => {
        var _a;
        setOpenModalFunds(true);
        setAccountFromParam((_a = checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id) === null || _a === void 0 ? void 0 : _a.toString());
        setAccountToParam(accountIdParam.toString());
    };
    const withdraw = (accountIdParam) => {
        var _a;
        setOpenModalFunds(true);
        setAccountFromParam(accountIdParam.toString());
        setAccountToParam((_a = checkingAccount === null || checkingAccount === void 0 ? void 0 : checkingAccount.id) === null || _a === void 0 ? void 0 : _a.toString());
    };
    const updateSaving = (virtualAccount) => {
        console.log(virtualAccount);
        if (virtualAccount)
            setStateUpdate(prev => (Object.assign(Object.assign({}, prev), { virtualAccount })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.totalSavingsContainer },
            React.createElement(WalletSection, { title: "Total Savings:", subTitle: ` ${formatAccountBalance(totalSavings)} KV`, viewTitle: location.pathname === '/student-dashboard/my-wallet/overview' ? ' ' : '', onClick: () => navigate('/student-dashboard/my-wallet/savings') },
                React.createElement("div", { className: Styles.walletComponentContainer }, pockets.map((pocket, index) => {
                    var _a;
                    return (React.createElement(WalletComponent, { key: `${index}_${pocket === null || pocket === void 0 ? void 0 : pocket.id}`, icon: getCategoryIcon((_a = pocket === null || pocket === void 0 ? void 0 : pocket.savingCategory) === null || _a === void 0 ? void 0 : _a.id), iconSettings: index === 0 ? React.createElement(TagDefault, { text: "Default" }) : React.createElement(IconSettingSavings, null), onClickSettings: () => updateSaving(pocket), iconDeposit: React.createElement(IconSavingsDeposit, null), onClickDeposit: () => deposit(pocket === null || pocket === void 0 ? void 0 : pocket.id), iconWithdraw: React.createElement(IconSavingsWithdraw, null), onClickWithdraw: () => withdraw(pocket === null || pocket === void 0 ? void 0 : pocket.id), title: index === 0 ? 'General Account' : (pocket === null || pocket === void 0 ? void 0 : pocket.savingName) || `Unnamed ${index + 1}`, amount: parseVirtualAccountBalance(pocket === null || pocket === void 0 ? void 0 : pocket.balance), total: parseVirtualAccountBalance(pocket === null || pocket === void 0 ? void 0 : pocket.savingGoal), color: "#89C900", progress: index !== 0, isDefault: index === 0 }));
                })))),
        React.createElement(ModalUpdateSaving, { validationModalUpdateSaving: validationModalUpdateSaving, manageVirtualAccounts: manageVirtualAccounts, SAVING_CATEGORIES: SAVING_CATEGORIES }),
        React.createElement(TransferFundsModalWrapper, { openModal: openModalFunds, setOpenModal: setOpenModalFunds, validationTransferFunds: validationTransferFunds, manageVirtualTransactions: manageVirtualTransactions, accountFromParam: accountFromParam, accountToParam: accountToParam, onTransferCompleted: () => reloadTransactions(), allowFromPockets: true })));
};
export default TotalSavings;
